export const whatsappTemplates = [
  {
    name: "Showroom Opening",
    image: "https://i.ibb.co/ZqhMLcG/darji-point.jpg",
    text: `🙏 *॥ શ્રી ચામુંડા માતા ॥* 🙏

સહર્ષ જણાવવાનું કે અમારા કુળદેવી *શ્રી ચામુંડા માતાજીની અશીમ કૃપાથી* અમારા નવા શોરૂમ

✨ *દરજી પોઈન્ટ – સિલેક્શન & ટેલર્સ* ✨

ના *શુભ ઉદ્ઘાટન* પ્રસંગે આપને તથા આપના પરિવારને હાર્દિક આમંત્રણ.

📅 *તારીખ:* ૦૨/૦૮/૨૦૨૬ (રવિવાર)
🕗 *સમય:* સવારે ૮:૦૦ વાગ્યાથી

📍 *સ્થળ:*
G-18, વ્રજ એન્ક્લેવ, લલિતા ચોકડી પાસે,
આંબતલાવડી રોડ, કતારગામ, સુરત.

આપની શુભ ઉપસ્થિતિ અમારે માટે આશીર્વાદ અને પ્રેરણારૂપ બનશે.
*આપ સહપરિવાર પધારી અમારા આનંદમાં સહભાગી થશો તેવી હાર્દિક અપેક્ષા.* 🙏🌸

*નિમંત્રક:*
*દિવ્યેશ આર. મકવાણા*
📞 73591 88376

રાજેશભાઈ હસમુખભાઈ મકવાણા
લલીતભાઈ હસમુખભાઈ મકવાણા
હિતેશભાઈ હસમુખભાઈ મકવાણા

🙏 *આભાર. આપની આતુરતાથી રાહ જોઈશું.* 🌹`,
  },
  {
    name: "Order Ready",
    text: `પ્રિય ગ્રાહક,

આ સંદેશ તમને જણાવવા માટે છે કે તમારો ઓર્ડર *{{1}}*  હવે પિક-અપ માટે તૈયાર છે. અમે વિનંતી કરીએ છીએ કે તમે શક્ય તેટલી વહેલી તકે તમારો ઓર્ડર એકત્રિત કરો. મહેરબાની કરીને નોંધ કરો કે આ સૂચનાની તારીખથી ૩૦ દિવસ પછી અસંગ્રહિત કરાયેલા કોઈપણ ઓર્ડર માટે અમે જવાબદાર હોઈશું નહીં.

જ્યારે તમે તમારો ઓર્ડર લેવા આવો ત્યારે કૃપા કરીને માન્ય ઇન્વૉઇસ/બિલ લાવવાની ખાતરી કરો. અમારા સ્ટોરનો સમય સવારે ૧૦ થી સાંજના ૯ છે અને અમારું સરનામું અમારી પ્રોફાઇલમાં પહેલેથી જ આપવામાં આવ્યું છે. જો તમને કોઈ પ્રશ્નો અથવા ચિંતાઓ હોય, તો કૃપા કરીને અમારો સંપર્ક કરવામાં અચકાશો નહીં.

તમારી ખરીદી બદલ આભાર, અને અમે તમને ટૂંક સમયમાં જોવા માટે આતુર છીએ.

શ્રેષ્ઠ શુભેચ્છા,
_દરજી પોઈન્ટ_`,
  },
  {
    name: "Order Placed",
    text: `{{1}},

દરજી પોઇન્ટ પસંદ કરવા માટે આભાર!

તમારા ઑર્ડરની વિગતો નીચે આપેલી છે:

ઓર્ડર નંબર: {{2}}
ડિલિવરી તારીખ: {{3}}
શર્ટ્સની સંખ્યા: {{4}}
પેન્ટ્સની સંખ્યા: {{5}}

જો તમારા ઑર્ડર બાબતમાં કોઈ પ્રશ્નો હોય તો કૃપા કરીને તમે જલ્દીથી અમારો સંપર્ક કરો. અમે હંમેશા તમારી મદદ કરવા માટે તૈયાર છીએ.`,
  },
];
